import { createChangeTierAction } from '../mobile_biller_support';

export const changeTier = createChangeTierAction;

export const downgradeTier = createChangeTierAction;
